import { render } from "./PersonalData.vue?vue&type=template&id=27912e55"
import script from "./PersonalData.vue?vue&type=script&lang=js"
export * from "./PersonalData.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./PersonalData.vue?vue&type=style&index=0&id=27912e55&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__